import { DefaultToolsOverrides } from './DefaultToolsOverrides'
import { FrameOverflowHandlers } from './FrameOverflowHandlers'
import { KeyboardShortcuts } from './KeyboardShortcuts'

export const Bootstrap = () => {
  return (
    <>
      <FrameOverflowHandlers />
      <DefaultToolsOverrides />
      <KeyboardShortcuts />
    </>
  )
}
